// extracted by mini-css-extract-plugin
export var container = "NavSectionLink-module--container--DDwik";